const DEFAULT_ALLOWED_PROTOCOLS = ["http:", "https:", "blob:"];

export const isSafeExternalUrl = (
  url?: string,
  allowedProtocols: string[] = DEFAULT_ALLOWED_PROTOCOLS,
): url is string => {
  if (!url) return false;

  try {
    const parsedUrl = new URL(url, window.location.origin);
    return allowedProtocols.includes(parsedUrl.protocol);
  } catch {
    return false;
  }
};

export const getSafeExternalUrl = (
  url?: string,
  allowedProtocols: string[] = DEFAULT_ALLOWED_PROTOCOLS,
): string | undefined => {
  return isSafeExternalUrl(url, allowedProtocols) ? url : undefined;
};

export const openExternalUrl = ({
  url,
  allowedProtocols = DEFAULT_ALLOWED_PROTOCOLS,
  features = "noopener,noreferrer",
}: {
  url?: string;
  allowedProtocols?: string[];
  features?: string;
}): boolean => {
  if (!isSafeExternalUrl(url, allowedProtocols)) return false;

  const openedWindow = window.open(url, "_blank", features);
  if (openedWindow) {
    openedWindow.opener = null;
  }
  return true;
};

export const getSafeRedirectPath = (path?: string): string | undefined => {
  if (!path) return undefined;
  if (!path.startsWith("/") || path.startsWith("//")) return undefined;
  return path;
};
